export default {
	platformNotifications: [],
	accessToken: null
}